<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="常见问题列表">
        <div class="row align--center mb-1">
          <div class="flex xs12 sm6">
            <va-input
              class="ma-0"
              :value="question"
              placeholder="search by question"
              @input="search"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex xs12 sm6">
            <div class="d-flex justify--end">
              <va-button color="info" small :to="{ name: 'saveCommonQuestion' }">新增常见问题</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="filteredData"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listCommonQuestion"
          api-mode
        >
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              :min="1"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="编辑" placement="top">
              <va-button flat small color="gray" icon="fa fa-pencil"
                :to='{path:`updateCommonQuestion/${props.rowData.id}`}'/>
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true;deleteId=props.rowData.id"/>
            </va-popover>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="删除常见问题"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />
      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import commonQuestionApi from '../../api/commonQuestion'

export default {
  data () {
    return {
      message: ['Required field'],
      questions: [],
      question: '',
      loading: true,
      pageSize: 10,
      totalPages: 1,
      deleteModal: false,
      deleteId: null,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:sort',
          title: '排序',
          width: '10%',
        },
        {
          name: 'question',
          title: '问题',
          width: '30%',
        },
        {
          name: 'answer',
          title: '回答',
          width: '50%',
        },
        {
          name: '__slot:actions',
          width: '10%',
          dataClass: 'text-left',
        },
      ]
    },
    filteredData () {
      if (!this.question || this.question.length < 1) {
        return this.questions
      }
      return this.questions.filter(item => {
        return item.question.toLowerCase().startsWith(this.question.toLowerCase())
      })
    },
  },
  created () {
    this.listCommonQuestion()
  },
  methods: {
    listCommonQuestion (pageNumber = 1) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
      }
      commonQuestionApi.listCommonQuestion(params)
        .then(response => {
          this.questions = response.questions
          this.totalPages = response.totalPage
          console.log(this.totalPages)
          this.loading = false
        })
    },
    confirmDelete () {
      if (this.deleteId === null) return
      commonQuestionApi.deleteCommonQuestion(this.deleteId).then(response => {
        if (response.success === true) {
          this.listCommonQuestion()
        }
      }).catch(error => alert(error))
    },
    search: debounce(function (question) {
      this.question = question
    }, 400),
    updateSortNum: function (params) {
      commonQuestionApi.updateCommonQuestion(params.id, params).then(response => {
        if (response.success === true) {
          this.listCommonQuestion()
        }
      }).catch(error => alert(error))
    },
  },
}

</script>
